import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-950">
                明
              </span>
              <span className="font-heading text-lg font-bold text-background-50">明明不喜欢</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              明明不喜欢，却总能找到值得一看的作品。我们专注影视资讯、剧情介绍与作品信息，
              覆盖电影与电视剧，帮你更快发现感兴趣的内容。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-background-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-leaf-line" /> 内容持续更新
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-movie-2-line" /> 电影 &amp; 电视剧
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">内容导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="text-background-300 transition-colors hover:text-accent-400">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-300 transition-colors hover:text-accent-400">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-300 transition-colors hover:text-accent-400">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 transition-colors hover:text-accent-400">
                  搜索作品
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">关于与联系</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li className="flex items-center gap-2 text-background-300">
                <i className="ri-mail-line" /> hello@mingmingbxh.com
              </li>
              <li className="flex items-center gap-2 text-background-300">
                <i className="ri-wechat-line" /> 明明不喜欢影视
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 明明不喜欢 · 影视内容平台 · 本网站内容为演示数据，仅供展示使用</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-information-line" /> 收藏与反馈均为演示功能，不保存至服务器
          </p>
        </div>
      </div>
    </footer>
  );
}